import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'prv-intra-net',
  templateUrl: './intra-net.component.html',
  styleUrls: ['./intra-net.component.scss'],
  standalone: false
})
export class IntranetComponent implements OnInit {

  // URL da Intranet
  private urlString = 'https://intranet.previmil.net/'; 
  public urlSegura: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    // Libera a URL para ser usada no iframe
    this.urlSegura = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlString);
  }
}
